import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit {
  searchString: any = '';
  sortby: any = 'id';
  payments: any;
  isloading=true;

  constructor(
    private SharedService: SharedService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.SharedService.allpayments().subscribe((response) => {
      this.payments = response.data.filter(payment => {
        if(payment.customer !== null){
          return payment;
        }
      })
      this.isloading = false;
    })
  }

  info(id: any): any {
    alert("details of "+ id);
  }

}
